export default {
    "name": "GetEnergyPrice",
    "kind": "HoudiniQuery",
    "hash": "d0a3d939fdca4b5636a2a0674de9afed4c2f809c0424cb525394cab0c2c6f25c",

    "raw": `query GetEnergyPrice {
  getEnergyPrice {
    ELECTRIC {
      amount
      currency
    }
    DIESEL {
      amount
      currency
    }
    HYBRID {
      amount
      currency
    }
    LPG {
      amount
      currency
    }
    GASOLINE {
      amount
      currency
    }
    BIFUEL {
      amount
      currency
    }
    CNG {
      amount
      currency
    }
    HYDROGEN {
      amount
      currency
    }
    ETHANOL {
      amount
      currency
    }
  }
}`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "getEnergyPrice": {
                "type": "EnergyPrice",
                "keyRaw": "getEnergyPrice",
                "nullable": true,

                "selection": {
                    "fields": {
                        "ELECTRIC": {
                            "type": "PriceCurrency",
                            "keyRaw": "ELECTRIC",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "amount": {
                                        "type": "Float",
                                        "keyRaw": "amount",
                                        "visible": true
                                    },

                                    "currency": {
                                        "type": "Currency",
                                        "keyRaw": "currency",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "DIESEL": {
                            "type": "PriceCurrency",
                            "keyRaw": "DIESEL",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "amount": {
                                        "type": "Float",
                                        "keyRaw": "amount",
                                        "visible": true
                                    },

                                    "currency": {
                                        "type": "Currency",
                                        "keyRaw": "currency",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "HYBRID": {
                            "type": "PriceCurrency",
                            "keyRaw": "HYBRID",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "amount": {
                                        "type": "Float",
                                        "keyRaw": "amount",
                                        "visible": true
                                    },

                                    "currency": {
                                        "type": "Currency",
                                        "keyRaw": "currency",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "LPG": {
                            "type": "PriceCurrency",
                            "keyRaw": "LPG",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "amount": {
                                        "type": "Float",
                                        "keyRaw": "amount",
                                        "visible": true
                                    },

                                    "currency": {
                                        "type": "Currency",
                                        "keyRaw": "currency",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "GASOLINE": {
                            "type": "PriceCurrency",
                            "keyRaw": "GASOLINE",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "amount": {
                                        "type": "Float",
                                        "keyRaw": "amount",
                                        "visible": true
                                    },

                                    "currency": {
                                        "type": "Currency",
                                        "keyRaw": "currency",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "BIFUEL": {
                            "type": "PriceCurrency",
                            "keyRaw": "BIFUEL",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "amount": {
                                        "type": "Float",
                                        "keyRaw": "amount",
                                        "visible": true
                                    },

                                    "currency": {
                                        "type": "Currency",
                                        "keyRaw": "currency",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "CNG": {
                            "type": "PriceCurrency",
                            "keyRaw": "CNG",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "amount": {
                                        "type": "Float",
                                        "keyRaw": "amount",
                                        "visible": true
                                    },

                                    "currency": {
                                        "type": "Currency",
                                        "keyRaw": "currency",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "HYDROGEN": {
                            "type": "PriceCurrency",
                            "keyRaw": "HYDROGEN",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "amount": {
                                        "type": "Float",
                                        "keyRaw": "amount",
                                        "visible": true
                                    },

                                    "currency": {
                                        "type": "Currency",
                                        "keyRaw": "currency",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "ETHANOL": {
                            "type": "PriceCurrency",
                            "keyRaw": "ETHANOL",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "amount": {
                                        "type": "Float",
                                        "keyRaw": "amount",
                                        "visible": true
                                    },

                                    "currency": {
                                        "type": "Currency",
                                        "keyRaw": "currency",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "policy": "CacheOrNetwork",
    "partial": false
};

"HoudiniHash=a393b3bbd5804b1287afa06ca264edcbfc54f79f60bdc77f43a07a8bce628f20";